// extracted by mini-css-extract-plugin
export default {"root":"PortfoliosTable_root__YGOur","terminatedDate":"PortfoliosTable_terminatedDate__RQSlt"};